import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

interface RecommendationCardProps {
  optimized: boolean;
}
export const RecommendationCard = styled('div')<RecommendationCardProps>(
  ({ theme, optimized }) => `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  padding: 6px 16px;
  border-radius: 8px;
  min-height: 42px;
  flex-wrap: wrap;
  background: linear-gradient(
    135deg,
    ${theme.palette.grey['02']} 0%,
    ${optimized ? theme.palette.status.online : theme.palette.status.warning}15 100%
  );
  border: 1px solid ${optimized ? theme.palette.status.online : theme.palette.primary['02']}30;
  box-shadow: 0 2px 8px ${optimized ? theme.palette.status.online : theme.palette.primary['03']}10;
`
);

export const ChannelBadge = styled('div')<{ highlight?: boolean }>(
  ({ theme, highlight }) => `
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 4px 12px;
  border-radius: 6px;
  gap: 6px;
  background-color: ${
    highlight
      ? theme.palette.status.warning
      : `${theme.palette.primary['01']}40`
  };
  color: ${
    highlight ? theme.palette.fixed.black : theme.palette.primary['01']
  } !important;
  border: 1.5px solid ${
    highlight
      ? theme.palette.status.warning + '30'
      : theme.palette.primary.main + '30'
  };
  box-shadow: 0 2px 6px ${
    highlight
      ? theme.palette.status.warning + '10'
      : theme.palette.primary.main + '10'
  };
`
);

export const RecommendationHeader = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '8px',
});

export const RecommendationContent = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '12px',
  flexWrap: 'wrap',
});

export const OptimizeButton = styled('button')(({ theme }) => ({
  height: 28,
  borderRadius: 6,
  padding: '2px 14px',
  fontSize: '12px',
  fontWeight: 700,
  border: 'none',
  outline: 'none',
  textTransform: 'none',
  backgroundColor: theme.palette.status.warning,
  color: theme.palette.fixed.black,
  boxShadow: `0 2px 8px ${theme.palette.status.warning}40`,
  transition: 'all 0.2s ease-in-out',
  gap: 6,
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.status.warning,
    filter: 'brightness(0.92)',
    boxShadow: `0 4px 12px ${theme.palette.status.warning}60`,
  },
  '&:disabled': {
    opacity: 0.65,
    cursor: 'not-allowed',
    color: theme.palette.fixed.black,
  },
}));

/** Band label in the recommendation card header */
export const BandLabelTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  color: theme.palette.text.primary,
  textAlign: 'left',
}));

/** Status label showing whether band is optimized or needs improvement */
export const StatusTypography = styled(Typography)<{ optimized: boolean }>(
  ({ theme, optimized }) => ({
    fontWeight: 600,
    color: optimized ? theme.palette.status.online : theme.palette.status.warning,
  })
);

/** Typography for channel badge labels (caption, weight 600, inherits color from badge) */
export const ChannelBadgeTypography = styled(Typography)({
  fontWeight: 600,
  color: 'inherit',
});
